import { config } from "@discovery/common-dplus/lib/utils/config-types";
export const authUrl = (base, host) => (path) => `${base}/${path}?returnUrl=${encodeURI(window.location.href)}&hostUrl=${host}`;
export const setAuthRedirectUrl = (returnUrl) => {
    localStorage.setItem("authRedirectUrl", returnUrl);
    const authRedirect = window.location.protocol +
        "//" +
        window.location.hostname +
        config.authenticationURLs.authRedirect;
    return authRedirect;
};

